export const FETCH_EXTENDED_PREVIEW_BEGIN = "FETCH_EXTENDED_PREVIEW_BEGIN";
export const FETCH_EXTENDED_PREVIEW_SUCCESS = "FETCH_EXTENDED_PREVIEW_SUCCESS";
export const FETCH_EXTENDED_PREVIEW_FAILURE = "FETCH_EXTENDED_PREVIEW_FAILURE";

export const CLEAR_EXTENDED_PREVIEW_STATE = "CLEAR_EXTENDED_PREVIEW_STATE";

export const FETCH_DOWNLOAD_DELETE_LANDING_BEGIN = "FETCH_DOWNLOAD_DELETE_LANDING_BEGIN";
export const FETCH_DOWNLOAD_DELETE_LANDING_SUCCESS = "FETCH_DOWNLOAD_DELETE_LANDING_SUCCESS";
export const FETCH_DOWNLOAD_DELETE_LANDING_FAILURE = "FETCH_DOWNLOAD_DELETE_LANDING_FAILURE";
